import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActionService } from 'src/app/core/services/action.service';
import { RouteService } from 'src/app/core/services/route.service';
import { Dropdown } from 'src/app/core/state/_actions/ignatius.actions';
import { Select2Data } from 'src/app/core/state/_models/general.model';
import { getDropdown } from 'src/app/core/state/_selectors/ignatius.selector';
import { SweetAlertOptions } from 'sweetalert2';
import { ConditionKeys } from '../../models/components.models';
import {
  alertPresets,
  AlertService,
  ToastTypes,
} from '../../services/alert.service';
import { columns, conditions, filterOptions, userConditions } from './conditions.constants';
import { DROPDOWN_VALUE_PLACEHOLDER } from '../../constants';
import { SubSink } from 'subsink';
@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss'],
})
export class ConditionsComponent implements OnInit, OnChanges {
  @Input('isError') isError: boolean = false;
  @Input('isLoading') isLoading: boolean = false;
  @Input('conditionType') conditionType: boolean = true;
  @Input('requireCondition') requireCondition: boolean = true;
  @Input('populate') populate: Array<any> = [];
  @Input('group') showGroup: boolean = false;
  @Input('title') title: string | null = null;
  @Input('filterColumns') filterColumns: Array<Select2Data> | null = [];
  @Input('isSummaryCondition') isSummaryCondition: boolean = false;
  @Input('loadCondition') loadCondition: boolean = true;
  @Input('passedTableKey') passedTableKey: string = '';
  @Input('keys') keys: ConditionKeys = {
    FieldKey: 'FieldKey',
    QueryCondition: 'QueryCondition',
    Value: 'Value',
    ConditionType: 'ConditionType',
    Conditions: 'Conditions',
  };
  otherKeys = {
    Date: 'Date',
    Date2: 'Date2',
  };
  @Output() filters = new EventEmitter<any>();
  @Output('reset') resetFilters = new EventEmitter();
  @Input('conditionOptions') conditionOptions: Array<any> | null = null;
  @Input('disabledQueryConditions') disabledQueryConditions: Array<any> | null = null;
  @Input() trigger: Subject<any> = new Subject<any>();
  /**
   * Text to display between groups like AND, OR etc
   */
  @Input() groupSeperatorText: string = '';
  /**
   * To set the maximum limit to add filter data.
   */
  MAXREPORSIZE: number = 0;
  get getfilterDataLimit(): number {
    return this.MAXREPORSIZE;
  }
  @Input() set filterDataLimit(limit: number) {
    if (limit > 0) {
      this.MAXREPORSIZE = limit;
    }
  };
  @Input('ConditionGroupType') ConditionGroupType: string = '';
  @Input('rolesOptions') rolesOptions: Array<Select2Data> = [];
  @Input('showHiddenConditions') showHiddenConditions: boolean = false;
  @Input('clearValidationOnDeselect') clearValidationOnDeselect: boolean = false;

  form!: UntypedFormArray;
  conditions = conditions;
  columns = columns;
  filterOptions = filterOptions;
  dateString = 'date';
  users: Array<Select2Data> = [];
  boolValues: Array<Select2Data> = [];

  regex = new RegExp('^\\d{4}-((0\\d)|(1[012]))-(([012]\\d)|3[01])$');
  createdByRegex = new RegExp('^tbl\\d+_createdby$');
  modifiedByRegex = new RegExp('^tbl\\d+_modifiedby$');
  dateCreatedRegex = new RegExp('^tbl\\d+_datecreated$');
  dateModifiedRegex = new RegExp('^tbl\\d+_datemodified$');
  ConditionDropDownId: string = 'ConditionDropDownId';
  userOptions: Array<Select2Data> = [];
  userConditionGroupOptions: Array<Select2Data> = userConditions;
  multipleChoiceFields = ['is equal', 'is not equal'];
  relatedChoiceField = ['empty', 'has value'];
  columnFieldype: any;
  emitSubject = new Subject<any>();
  emitSubject2 = new Subject<any>();
  removingGroup: boolean = false;
  removingCondition: boolean = false;
  isDataPopulated: boolean = false
  subsink: SubSink = new SubSink();

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private action: ActionService,
    private route: RouteService,
    private alert: AlertService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabledQueryConditions && changes.disabledQueryConditions.previousValue !== changes.disabledQueryConditions.currentValue) {
      this.disableOptionAsPerPassedOptions(changes.disabledQueryConditions.previousValue)
    }
    if (changes.filterColumns && changes.filterColumns.previousValue !== changes.filterColumns.currentValue && changes.filterColumns.currentValue) {
      this.form?.controls?.forEach(control => {
        ((control as UntypedFormGroup).controls[this.keys.Conditions] as UntypedFormArray).controls.forEach(conditionControl => {
          (conditionControl as UntypedFormGroup).patchValue({
            ColumnOptions: this.filterColumns
          })
        });
      });
    }
    this.userFormFieldReset();
  }

  ngOnInit(): void {
    // if (this.loadCondition)
    //   this.store.dispatch(new LoadUsers(this.route.getApplicationId(), true));
    this.initForm();
    this.loadSubscribers();
    this.populateData(this.populate);
    this.subsink.add(
      this.trigger.subscribe((array) => {
        this.form.clear();
        this.populate = array;
        // if (this.filterColumns != null && this.filterColumns?.length != 0)
        this.populateData(array);
      }));
    this.conditionOptions = conditions;
  }

  /**
   * Populate data if populate
   */
  populateData = (populate: Array<any>) => {
    if (!populate?.length) return this.addGroup();
    for (let filter in populate) {
      this.addGroup();
      if (populate[filter][this.keys.Conditions] == undefined) return;
      let condCount = populate[filter][this.keys.Conditions].length - 1;
      if (condCount < 0) {
        this.form.at(+filter).patchValue(populate[filter], {
          emitEvent: false,
        });
        continue;
      }
      while (condCount--) {
        this.addfilter(+filter);
      }
      if (populate[filter]?.[this.keys.Conditions] != null) {
        populate[filter]?.[this.keys.Conditions]?.forEach((element: any) => {
          this.filterColumns?.forEach((field) => {
            if (
              (field.value === element.FieldKey || field.value === element.ColumnKey) &&
              field.fieldType === 'ENUM2' &&
              !Array.isArray(element.Value)
            ) {
              element.Value = element.Value?.split(';');
            }
          });

          if (
            element[this.keys.QueryCondition] === 'before_date' ||
            element[this.keys.QueryCondition] === 'after_date' ||
            element[this.keys.QueryCondition] === 'on_or_before_date' ||
            element[this.keys.QueryCondition] === 'on_or_after_date'
          ) {
            if (this.regex.test(element.Value)) {
              element.IsCustomDate = true;
              var dates = element.Value.split(',');
              element.Date = dates[0];
              element.Value = "customdate";
            } else {
              this.patchFilter(element);
            }
          } else if (
            element[this.keys.QueryCondition] === 'between_date' ||
            element[this.keys.QueryCondition] === 'not_between_date'
          ) {
            if (element.Value) {
              var dates = element.Value.split(',');
              element.Date = dates[0];
              element.Date2 = dates[1];
            }
          } else if (element[this.keys.QueryCondition] === 'true or false') {
            element.ValuesFilter = this.boolValues;
            element.Value = +element.Value;
          } else {
            this.patchFilter(element);
          }
        });
      }

      this.form.at(+filter).patchValue(populate[filter], {
        emitEvent: false,
      });

      this.form.at(+filter).markAsDirty();
    }
    if (this.form.dirty) {
      this.filters.emit({ form: this.form });
    }
  };

  /**
   * Init form
   */
  initForm = () => {
    this.form = this.fb.array([]);
    this.boolValues.push(
      {
        label: 'true',
        value: 1,
      },
      {
        label: 'false',
        value: 0,
      }
    );
  };

  /**
   * Form control
   */
  get controls() {
    return this.form?.controls;
  }

  /**
   * Subscribers
   */
  loadSubscribers = () => {
    this.subsink.add(
      this.form.valueChanges.subscribe(() => {
        setTimeout(() => {
          if ((this.removingCondition || this.removingGroup)) {
            this.form.markAsDirty();
          }
          this.filters.emit({ form: this.form, isFilterRemoved: this.removingCondition || this.removingGroup });
          if ((this.removingCondition || this.removingGroup)) {
            this.removingCondition = false;
            this.removingGroup = false;
          }
        }, 0);
      }));



    // this.store
    //   .pipe(
    //     select(getUsers),
    //     filter((users) => !!users[this.route.getApplicationId()]),
    //     map((users) => users[this.route.getApplicationId()])
    //   )
    //   .subscribe((users) => {
    //     this.users = users.map((u) => ({
    //       label: u.Email,
    //       value: u.Email,
    //     }));
    //   });
  };

  /**
   * Handle ConditionType changes to clear validation errors when deselected
   * @param groupIndex - index of the condition group
   * @param conditionTypeValue - new value of ConditionType
   */
  handleConditionTypeChange = (groupIndex: number, conditionTypeValue: any) => {
    const group = this.form.at(groupIndex) as UntypedFormGroup;
    const conditionsArray = group.get(this.keys.Conditions) as UntypedFormArray;

    // If ConditionType is cleared/deselected (empty, null, or '--select--')
    if (!conditionTypeValue || conditionTypeValue === '--select--') {
      // Clear all validation errors and reset condition fields
      conditionsArray.controls.forEach((conditionControl) => {
        const condition = conditionControl as UntypedFormGroup;

        // Clear validators for all condition fields
        Object.keys(condition.controls).forEach(controlName => {
          const control = condition.get(controlName);
          if (control && ['FieldKey', 'QueryCondition', 'Value'].includes(controlName)) {
            control.clearValidators();
            control.updateValueAndValidity();
            // Reset the value to clear any red error states
            // control.setValue(controlName === 'Value' ? '' : null);
            control.markAsUntouched();
            control.markAsPristine();
          }
        });
      });

      // Mark the group as valid
      group.updateValueAndValidity();
    } else {
      // ConditionType is selected, re-apply required validators if needed
      conditionsArray.controls.forEach((conditionControl) => {
        const condition = conditionControl as UntypedFormGroup;

        // Re-add required validators for condition fields
        ['FieldKey', 'QueryCondition', 'Value'].forEach(controlName => {
          const control = condition.get(controlName);
          if (control && this.requireCondition) {
            control.setValidators([Validators.required]);
            control.updateValueAndValidity();
          }
        });
      });
    }
  };

  /**
   * Convert group's controls as array
   * @param index group index
   * @returns
   */
  getGroupControls: any = (group: UntypedFormGroup) =>
    (group.controls[this.keys.Conditions] as UntypedFormArray)?.controls || [];

  /**
   * Parse to form group
   * @param group
   */
  formGroupParse = (group: any) => group as UntypedFormGroup;

  /**
   * Get a particular group's Condition value
   * @param groupIndex
   * @param conditionIndex
   */
  getConditonsValue = (groupIndex: number, conditionIndex: number) =>
    (this.form.at(groupIndex).get(this.keys.Conditions) as UntypedFormArray).at(
      conditionIndex
    )?.value;

  /**
   * Add filter
   */
  addfilter = (groupIndex: number) => {
    if (
      this.getfilterDataLimit != 0 &&
      (this.form.at(groupIndex).get(this.keys.Conditions) as UntypedFormArray)
        ?.controls.length >= this.getfilterDataLimit
    ) {
      this.alert.toast(
        ToastTypes.ERROR,
        'Max Limit Exceeded',
        `You can't add more than ${this.MAXREPORSIZE} filters.`
      );
      return;
    }
    // Check current ConditionType state to determine if validators should be applied
    const group = this.form.at(groupIndex) as UntypedFormGroup;
    const conditionTypeValue = group.get(this.keys.ConditionType)?.value;

    const shouldSkipValidators = !this.requireCondition || (this.clearValidationOnDeselect && (!conditionTypeValue || conditionTypeValue === '--select--'));

    const requiredValidator = shouldSkipValidators ? [] : Validators.required;

    const newConditionGroup = this.fb.group({
      [this.keys.FieldKey]: [null, requiredValidator],
      [this.keys.QueryCondition]: [null, requiredValidator],
      [this.keys.Value]: [null, requiredValidator],
      CurrentFieldType: [''],
      ColumnOptions: [JSON.parse(JSON.stringify(this.filterColumns))],
      ConditionOptions: [
        JSON.parse(JSON.stringify(conditions.map(condition => {
          return {
            ...condition,
            options: condition.options.map(option => ({ ...option, hide: !this.showHiddenConditions ? option.hide : false }))
          }
        }))) as Array<any>,
      ],
      Date: [''],
      Date2: [''],
      IsCustomDate: [false],
      ValuesFilter: [null],
      ConditionGroupType: [''],
    });

    const haveValidatorsApplied = this.clearValidationOnDeselect && !shouldSkipValidators;

    if (haveValidatorsApplied) {
      // Mark each required field as pending immediately to ensure they show as invalid
      newConditionGroup.get(this.keys.FieldKey)?.markAsPending();
      newConditionGroup.get(this.keys.QueryCondition)?.markAsPending();
      newConditionGroup.get(this.keys.Value)?.markAsPending();
    }

    (this.form.at(groupIndex).get(this.keys.Conditions) as UntypedFormArray).push(newConditionGroup);

    // Update parent group validity after adding new control
    if (haveValidatorsApplied) {
      const parentGroup = this.form.at(groupIndex) as UntypedFormGroup;
      parentGroup.updateValueAndValidity();

      // Only trigger change detection if the form structure is properly initialized
      // This prevents test failures when ConditionType control doesn't exist yet
      if (this.cdr && parentGroup.get('ConditionType')) {
        this.cdr.detectChanges();
      }
    }
  };

  /**
   * Add group
   */
  addGroup = () => {
    const groupIndex = this.form.length;
    const newGroup = this.fb.group({
      [this.keys.ConditionType]: [
        null,
        this.conditionType ? Validators.required : [],
      ],
      [this.keys.Conditions]: this.fb.array([]),
    });

    this.form.push(newGroup);

    // Add subscription for ConditionType changes for this new group
    if (this.clearValidationOnDeselect) {
      this.subsink.add(
        newGroup.get(this.keys.ConditionType)?.valueChanges.subscribe((conditionTypeValue) => {
          this.handleConditionTypeChange(groupIndex, conditionTypeValue);
        })
      );
    }

    this.addfilter(groupIndex);
  };

  /**
   * Remove filter
   * @param index from index
   */
  removeFilter = (groupIndex: number, conditionIndex: number) => {
    (this.form.at(groupIndex).get(this.keys.Conditions) as UntypedFormArray).removeAt(
      conditionIndex
    );
    this.removingCondition = true;
  };

  /**
   * Remove group
   * @param index from index
   */
  removeGroup = (index: number) => {
    this.form.removeAt(index);
    this.removingGroup = true;
  };

  selectedColumn = (e: any, filter: AbstractControl) => {
    var currentColumnType = null;
    var fieldIndex = -1;
    var fieldType: any = null;
    let isRelated = false;
    this.filterColumns?.forEach((field, index) => {
      if (field.value == filter.value[this.keys.FieldKey]) {
        fieldIndex = index;
        fieldType = field.fieldType;
        // this.columnFieldype = field.fieldType;
      }
    });
    if (fieldType === 'ENUM' || fieldType === 'ENUM2') {
      const emitSubject2 = new Subject<void>();
      this.subsink.add(
        this.store.pipe(
          select(getDropdown),
          takeUntil(emitSubject2)
        ).subscribe(data => {
          if (data && Object.keys(data).length && data[filter?.value[this.keys.FieldKey]]) {
            if (filter.value[this.keys.QueryCondition] && this.multipleChoiceFields.includes(filter.value[this.keys.QueryCondition])) {
              filter.patchValue({
                ValuesFilter: data[filter?.value[this.keys.FieldKey]]?.filter((option: any) => {
                  if (option.IsActive) return true;
                  else if (fieldType === 'ENUM' && option.Value === filter.value[this.keys.Value]) return true;
                  else if (fieldType === 'ENUM2' && filter.value[this.keys.Value].split(';').includes(option.Value)) return true;
                  return false
                }).map((option: any) => {
                  return {
                    label: option.Name,
                    value: option.Value
                  }
                })
              });
            }
            emitSubject2.next();
            emitSubject2.complete();
          } else {
            this.store.dispatch(new Dropdown(filter?.value[this.keys.FieldKey]));
          }
        }));
      if (fieldType === 'ENUM2' && filter?.value[this.keys.Value]) {
        if (!Array.isArray(filter.value[this.keys.Value])) {
          filter.patchValue({
            Value: filter.value?.[this.keys.Value]?.split(';')
          })
        }
      }
    }
    if (fieldIndex >= 0) {
      var field =
        this.filterColumns == null ? null : this.filterColumns[fieldIndex];
      if (field != null) {
        var fieldName = field.name == undefined ? '' : field.name;
        if (
          field.name == 'createdby' ||
          field.name == 'modifiedby' ||
          this.createdByRegex.test(fieldName) ||
          this.modifiedByRegex.test(fieldName)
        ) {
          currentColumnType = 'user';
        } else if (field.name == 'id') {
          currentColumnType = 'id';
        } else if (
          field.name == 'datecreated' ||
          field.name == 'datemodified' ||
          this.dateCreatedRegex.test(fieldName) ||
          this.dateModifiedRegex.test(fieldName)
        ) {
          currentColumnType = 'datetime';
        } else if (field.fieldType == 'TINYINT(1)') {
          currentColumnType = 'boolean';
        } else if (field.fieldType === 'ENUM' || field.fieldType === 'ENUM2') {
          currentColumnType = field.fieldType;
        } else if (field.fieldType === 'EMAIL') {
          currentColumnType = field.fieldType;
        } else if (field.fieldType === 'VARCHAR(15)') {
          currentColumnType = field.fieldType;
        } else {
          currentColumnType = field.generalType;
        }

        if (field.name?.includes('related')) {
          isRelated = true;
        }
      }
    }
    filter.patchValue({
      CurrentFieldType: currentColumnType,
      // [this.keys[this.keys.QueryCondition]]: '',
      // [this.keys.Value]: '',
    });
    if (filter.value.Value && Array.isArray(filter.value.Value) && fieldType !== 'ENUM2') {
      filter.patchValue({
        [this.keys.Value]: filter.value.Value[0],
      });
    }

    this.disableFilterOptions(filter, currentColumnType, fieldType, isRelated);
    this.getQueryCondition(filter);
  };

  disableFilterOptions(filter: AbstractControl, currentColumnType: any, fieldType: any, isRelated: boolean = false) {
    if (currentColumnType != null) {
      var options = filter.value.ConditionOptions as Array<any>;
      options.forEach((element: any) => {
        element.options.forEach((el: any) => {
          var types = el.types as Array<any>;
          if (types.length != 0) {
            if (el.types.includes(currentColumnType)) {
              el.disabled = false;
            } else {
              el.disabled = true;
            }
          }
          if (this.multipleChoiceFields.includes(el.value) && (fieldType === 'ENUM' || fieldType === 'ENUM2')) {
            el.disabled = false;
          }
          if (this.relatedChoiceField.includes(el.value) && isRelated) {
            el.disabled = false;
          }
          if (this.disabledQueryConditions && this.disabledQueryConditions.length && this.disabledQueryConditions.includes(el.value)) {
            el.disabled = true;
          }
          if (el.value === filter.value[this.keys.QueryCondition] && el.disabled) {
            filter.patchValue({
              [this.keys.QueryCondition]: null,
              [this.keys.Value]: null
            })
          }
        });
      });
      filter.patchValue({
        ConditionOptions: options,
      });
    }
  }

  disableOptionAsPerPassedOptions(previousQueryCondition: any) {
    for (let group of this.controls!) {
      for (let filter of this.getGroupControls(this.formGroupParse(group))) {
        var options = filter.value.ConditionOptions as Array<any>;
        options.forEach((element: any) => {
          element.options.forEach((el: any) => {
            if (this.disabledQueryConditions && this.disabledQueryConditions.length && this.disabledQueryConditions.includes(el.value)) {
              el.disabled = true;
            }
            if (previousQueryCondition && previousQueryCondition.length && previousQueryCondition.includes(el.value) && el.types.includes(filter.value.CurrentFieldType)) {
              el.disabled = false;
            }
            if (el.value === filter.value[this.keys.QueryCondition] && el.disabled) {
              filter.patchValue({
                [this.keys.QueryCondition]: null,
                [this.keys.Value]: null
              })
            }
          });
        });
        filter.patchValue({
          ConditionOptions: options,
        });
      }
    }
  }

  getExtractedValue(fieldValue: any) {
    const match = fieldValue.toString().match(/(?:^.*?_)?([a-zA-Z_]+)$/);
    return match ? match[1] : fieldValue
  }

  getQueryCondition(filter: AbstractControl) {
    let checkQueryCondition: string[] = ['is equal to user'];
    let fieldCondition: string[] = ['equal to value in field', 'not equal to value in field']
    if (!filter.value.Value && checkQueryCondition.includes(filter.value.QueryCondition)) {
      filter.patchValue({
        Value: DROPDOWN_VALUE_PLACEHOLDER,
      });
    } else if (filter.value.Value == DROPDOWN_VALUE_PLACEHOLDER) {
      filter.patchValue({
        Value: '',
      })
    }
    var valueNotRequiredConditions = [
      'has value',
      'empty',
      'currentuser',
      'between_date',
      'not_between_date',
      'ccu',
    ];

    let disabledFields = [
      'has value',
      'empty',
      'currentuser',
      'ccu',
    ]

    if (
      valueNotRequiredConditions.includes(
        filter.value[this.keys.QueryCondition]
      )
    ) {
      if (
        disabledFields.includes(
          filter.value[this.keys.QueryCondition]
        )
      ) {
        filter.patchValue({
          Value: null
        })
      }
      filter.get('Value')?.clearValidators();
      filter.get('Value')?.updateValueAndValidity();
    } else {
      filter.get('Value')?.setValidators([Validators.required]);
      filter.get('Value')?.updateValueAndValidity();
    }

    var queryCondition = filter.value[this.keys.QueryCondition];
    var columns: Select2Data[] = JSON.parse(JSON.stringify(this.filterColumns));

    if (columns != null && !this.isSummaryCondition) {
      columns = columns.map(function (value, index) {
        return {
          label: value.label,
          value: value.name!,
          name: value.name,
          fieldType: value.fieldType,
          generalType: value.generalType,
          value2: value.value,
        };
      });
    }

    if (columns != null && this.isSummaryCondition) {
      columns = columns.map(function (value, index) {
        return {
          label: value.label,
          value: value.tableId + '_' + value.name!,
          name: value.name,
          fieldType: value.fieldType,
          generalType: value.generalType,
          value2: value.value,
        };
      });
    }

    if (
      filter.value.ValuesFilter == undefined ||
      filter.value.ValuesFilter.length == 0 ||
      (filter.value.ValuesFilter.length == 1 &&
        filter.value.ValuesFilter[0].label == 'Select Custom Date')
    ) {
      filter.patchValue({
        ValuesFilter: columns,
      });
    }
    var dateTypes = ['date', 'datetime'];

    var queryCondtions = [
      'before_date',
      'on_or_before_date',
      'after_date',
      'on_or_after_date',
    ];
    (filter as UntypedFormGroup).controls.Date.clearValidators();
    (filter as UntypedFormGroup).controls.Date2.clearValidators();
    if (queryCondtions.includes(queryCondition)) {
      var customIndex = null;
      if (columns != null) {
        columns!.forEach(function (column, index) {
          if (column.name === 'Select Custom Date') {
            customIndex = index;
          }
        });
      }

      if (customIndex == null) {
        var valuesFilter = [];
        if (columns != null) {
          columns!.forEach((column: Select2Data) => {
            if (
              column.generalType === 'date' ||
              column.generalType === 'datetime' ||
              column.name === 'datecreated' ||
              column.name === 'datemodified' ||
              this.dateCreatedRegex.test(column.name!) ||
              this.dateModifiedRegex.test(column.name!)
            ) {
              if (filter.value[this.keys.FieldKey] != column.value2) {
                valuesFilter.push(column);
              }
            }
          });
        }
        valuesFilter.push({
          label: 'Select Custom Date',
          value: 'customdate',
        });
        valuesFilter = valuesFilter.filter((field: Select2Data) => {
          if (
            this.isSummaryCondition &&
            filter.value[this.keys.FieldKey] !== field.value2
          ) {
            const targetColumn = columns.find(
              (column) => column.value2 === filter.value[this.keys.FieldKey]
            );

            if (targetColumn) {
              const { name: fieldName, value: fieldValue } = targetColumn;
              const extractedFieldValue = this.getExtractedValue(fieldValue || '');
              const extractedFilterValue = this.getExtractedValue(field.value || '');

              if (extractedFieldValue === extractedFilterValue) {
                const cleanValue1 = fieldValue?.toString().replace(fieldName || '', '').replace(/^_+|_+$/g, '');
                const cleanValue2 = field.value?.toString().replace(field.name || '', '').replace(/^_+|_+$/g, '');

                if (cleanValue1 === cleanValue2) return true;
                if (fieldName === field.name) return true;

                if (fieldName && field.name) {
                  const nameDiff = fieldName.length - field.name.length;
                  const largerName = nameDiff > 0 ? fieldName : field.name;
                  const smallerName = nameDiff > 0 ? field.name : fieldName;
                  const cleanedDifference = largerName.replace(smallerName, '').replace(/^_+|_+$/g, '');

                  return cleanedDifference.includes('_');
                }
              }
            }
          }
          return true;
        })

        filter.patchValue({
          ValuesFilter: valuesFilter,
        });
      }
    } else if (queryCondition == 'true or false') {
      filter.patchValue({
        Value: +filter.value.Value,
        IsCustomDate: false
      })
    } else {
      filter.patchValue({
        IsCustomDate: false,
      });
      var customIndex = null;
      if (filter.value.ValuesFilter == null) {
        filter.patchValue({
          ValuesFilter: [],
        });
      }

      filter.value.ValuesFilter!?.forEach(function (
        column: Select2Data,
        index: any
      ) {
        if (column.name === 'Select Custom Date') {
          customIndex = index;
        }
      });

      if (customIndex != null) {
        filter.patchValue({
          ValuesFilter: columns,
        });
      }

      const selectedField = this.filterColumns?.filter((column) => column.value === filter?.value[this.keys.FieldKey])

      if (filter.value.CurrentFieldType == 'user') {
        filter.patchValue({
          ValuesFilter: columns
        });
        filter.patchValue({
          ValuesFilter: filter.value.ValuesFilter.filter(
            (field: Select2Data) => {
              if (
                this.isSummaryCondition &&
                field.generalType == filter.value.CurrentFieldType &&
                filter.value[this.keys.FieldKey] !== field.value2
              ) {
                const targetColumn = columns.find(
                  (column) => column.value2 === filter.value[this.keys.FieldKey]
                );

                if (targetColumn) {
                  const { name: fieldName, value: fieldValue } = targetColumn;
                  const extractedFieldValue = this.getExtractedValue(fieldValue || '');
                  const extractedFilterValue = this.getExtractedValue(field.value || '');

                  if (extractedFieldValue === extractedFilterValue) {
                    const cleanValue1 = fieldValue?.toString().replace(fieldName || '', '').replace(/^_+|_+$/g, '');
                    const cleanValue2 = field.value?.toString().replace(field.name || '', '').replace(/^_+|_+$/g, '');

                    if (cleanValue1 === cleanValue2) return true;
                    if (fieldName === field.name) return true;

                    if (fieldName && field.name) {
                      const nameDiff = fieldName.length - field.name.length;
                      const largerName = nameDiff > 0 ? fieldName : field.name;
                      const smallerName = nameDiff > 0 ? field.name : fieldName;
                      const cleanedDifference = largerName.replace(smallerName, '').replace(/^_+|_+$/g, '');

                      return cleanedDifference.includes('_');
                    }
                  }
                }
              }
              return (
                (field.generalType == filter.value.CurrentFieldType ||
                  field.name == 'createdby' ||
                  field.name == 'modifiedby' ||
                  this.createdByRegex.test(field.name!) ||
                  this.modifiedByRegex.test(field.name!)) &&
                filter.value[this.keys.FieldKey] != field.value2
              );
            }
          ),
        });
      } else if (filter.value.CurrentFieldType == 'boolean') {
        filter.patchValue({
          ValuesFilter: columns
        });
        filter.patchValue({
          ValuesFilter: filter.value.ValuesFilter.filter(
            (field: Select2Data) => {
              if (
                this.isSummaryCondition &&
                field.fieldType == 'TINYINT(1)' &&
                filter.value[this.keys.FieldKey] !== field.value2
              ) {
                const targetColumn = columns.find(
                  (column) => column.value2 === filter.value[this.keys.FieldKey]
                );

                if (targetColumn) {
                  const { name: fieldName, value: fieldValue } = targetColumn;
                  const extractedFieldValue = this.getExtractedValue(fieldValue || '');
                  const extractedFilterValue = this.getExtractedValue(field.value || '');

                  if (extractedFieldValue === extractedFilterValue) {
                    const cleanValue1 = fieldValue?.toString().replace(fieldName || '', '').replace(/^_+|_+$/g, '');
                    const cleanValue2 = field.value?.toString().replace(field.name || '', '').replace(/^_+|_+$/g, '');

                    if (cleanValue1 === cleanValue2) return true;
                    if (fieldName === field.name) return true;

                    if (fieldName && field.name) {
                      const nameDiff = fieldName.length - field.name.length;
                      const largerName = nameDiff > 0 ? fieldName : field.name;
                      const smallerName = nameDiff > 0 ? field.name : fieldName;
                      const cleanedDifference = largerName.replace(smallerName, '').replace(/^_+|_+$/g, '');

                      return cleanedDifference.includes('_');
                    }
                  }
                }
              }
              return (
                field.fieldType == 'TINYINT(1)' &&
                filter.value[this.keys.FieldKey] != field.value2
              );
            }
          ),
        });
      } else if (dateTypes.includes(filter.value.CurrentFieldType)) {
        filter.patchValue({
          ValuesFilter: columns
        });
        filter.patchValue({
          ValuesFilter: filter.value.ValuesFilter.filter(
            (field: Select2Data) => {
              if (
                this.isSummaryCondition &&
                filter.value[this.keys.FieldKey] !== field.value2
              ) {
                const targetColumn = columns.find(
                  (column) => column.value2 === filter.value[this.keys.FieldKey]
                );

                if (targetColumn) {
                  const { name: fieldName, value: fieldValue } = targetColumn;
                  const extractedFieldValue = this.getExtractedValue(fieldValue || '');
                  const extractedFilterValue = this.getExtractedValue(field.value || '');

                  if (extractedFieldValue === extractedFilterValue) {
                    const cleanValue1 = fieldValue?.toString().replace(fieldName || '', '').replace(/^_+|_+$/g, '');
                    const cleanValue2 = field.value?.toString().replace(field.name || '', '').replace(/^_+|_+$/g, '');

                    if (cleanValue1 === cleanValue2) return true;
                    if (fieldName === field.name) return true;

                    if (fieldName && field.name) {
                      const nameDiff = fieldName.length - field.name.length;
                      const largerName = nameDiff > 0 ? fieldName : field.name;
                      const smallerName = nameDiff > 0 ? field.name : fieldName;
                      const cleanedDifference = largerName.replace(smallerName, '').replace(/^_+|_+$/g, '');

                      return cleanedDifference.includes('_');
                    }
                  }
                }
              }
              var r =
                (dateTypes.includes(field.generalType!) ||
                  field.name == 'datecreated' ||
                  field.name == 'datemodified') &&
                filter.value[this.keys.FieldKey] != field.value2;
              return r;
            }
          ),
        });
        if (['between_date', 'not_between_date'].includes(queryCondition)) {
          (filter as UntypedFormGroup).controls.Date.setValidators(Validators.required);
          (filter as UntypedFormGroup).controls.Date2.setValidators(Validators.required);
          (filter as UntypedFormGroup).updateValueAndValidity();
        }
      } else if (this.multipleChoiceFields.includes(queryCondition) && (selectedField?.[0]?.fieldType === 'ENUM' || selectedField?.[0]?.fieldType === 'ENUM2')) {
        const emitSubject = new Subject<void>();
        this.subsink.add(
          this.store.pipe(
            select(getDropdown),
            takeUntil(emitSubject)
          ).subscribe((data: any) => {
            let valuesFilter = null;
            let value = filter?.value?.Value || null;

            if (data && Object.keys(data).length > 0) {
              const fieldData = data[filter.value[this.keys.FieldKey]];

              if (fieldData &&
                !this.isArraysEqual(fieldData, filter.value.ValuesFilter) &&
                this.multipleChoiceFields.includes(filter.value[this.keys.QueryCondition])) {

                valuesFilter = fieldData.filter((option: any) => {
                  if (option.IsActive) return true;
                  else if (selectedField?.[0]?.fieldType === 'ENUM' && option.Value === filter.value[this.keys.Value]) return true;
                  else if (selectedField?.[0]?.fieldType === 'ENUM2' && filter.value[this.keys.Value].split(';').includes(option.Value)) return true;
                  return false
                }).map((value: any) => ({
                  label: value.Name,
                  value: value.Value
                }));
                emitSubject.next()
                emitSubject.complete();
              }
            }

            filter.patchValue({
              ValuesFilter: valuesFilter,
              Value: value
            });
          }));
      } else {
        filter.patchValue({
          ValuesFilter: columns
        })
        filter.patchValue({
          ValuesFilter: filter.value.ValuesFilter?.filter(
            (field: Select2Data) => {
              if (
                this.isSummaryCondition &&
                (field.generalType === filter.value.CurrentFieldType ||
                  field.fieldType === filter.value.CurrentFieldType) &&
                filter.value[this.keys.FieldKey] !== field.value2
              ) {
                const targetColumn = columns.find(
                  (column) => column.value2 === filter.value[this.keys.FieldKey]
                );

                if (targetColumn) {
                  const { name: fieldName, value: fieldValue } = targetColumn;
                  const extractedFieldValue = this.getExtractedValue(fieldValue || '');
                  const extractedFilterValue = this.getExtractedValue(field.value || '');

                  if (extractedFieldValue === extractedFilterValue) {
                    const cleanValue1 = fieldValue?.toString().replace(fieldName || '', '').replace(/^_+|_+$/g, '');
                    const cleanValue2 = field.value?.toString().replace(field.name || '', '').replace(/^_+|_+$/g, '');

                    if (cleanValue1 === cleanValue2) return true;
                    if (fieldName === field.name) return true;

                    if (fieldName && field.name) {
                      const nameDiff = fieldName.length - field.name.length;
                      const largerName = nameDiff > 0 ? fieldName : field.name;
                      const smallerName = nameDiff > 0 ? field.name : fieldName;
                      const cleanedDifference = largerName.replace(smallerName, '').replace(/^_+|_+$/g, '');

                      return cleanedDifference.includes('_');
                    }
                  }
                }
              }
              var r =
                (field.generalType == filter.value.CurrentFieldType ||
                  field.fieldType === filter.value.CurrentFieldType) &&
                field.name != 'datecreated' &&
                field.name != 'datemodified' &&
                field.name != 'createdby' &&
                field.name != 'modifiedby' &&
                !this.createdByRegex.test(field.name!) &&
                !this.modifiedByRegex.test(field.name!) &&
                !this.dateCreatedRegex.test(field.name!) &&
                !this.dateModifiedRegex.test(field.name!) &&
                field.fieldType != 'TINYINT(1)' &&
                filter.value[this.keys.FieldKey] != field.value2;
              return r;
            }
          ),
        });
      }
    }
    if (queryCondition !== 'true or false') {
      filter.patchValue({
        Value: filter?.value?.Value
          ? fieldCondition.includes(filter.value.QueryCondition) &&
            filter.value?.CurrentFieldType === 'ENUM2' &&
            Array.isArray(filter.value?.Value)
            ? filter.value.Value[0]
            : filter.value.Value
          : null,
      });
    }
  }

  getValueSelection(filter: AbstractControl) {
    if (filter.value.Value === 'customdate') {
      filter.patchValue({
        IsCustomDate: true,
      });
      (filter as UntypedFormGroup).controls.Date.setValidators(Validators.required);
    } else {
      filter.patchValue({
        IsCustomDate: false,
      });
      (filter as UntypedFormGroup).controls.Date.clearValidators();
    }

    this.filterColumnFieldsBasedOnValueSelection(filter);

  }

  filterColumnFieldsBasedOnValueSelection(filter: AbstractControl) {
    let columns: Select2Data[] = JSON.parse(JSON.stringify(this.filterColumns));

    // Normalize columns based on isSummaryCondition
    if (columns) {
      columns = columns.map(value => ({
        label: value.label,
        value: this.isSummaryCondition ? `${value.tableId}_${value.name}` : value.name!,
        name: value.name,
        fieldType: value.fieldType,
        generalType: value.generalType,
        value2: value.value,
      }));
    }

    const selectedValueField = filter.value[this.keys.Value];

    // Build a map for O(1) access
    const columnMap = new Map(columns.map(col => [col.value, col]));

    const selectedField = selectedValueField ? columnMap.get(selectedValueField) : null;

    const updatedColumnOptions = filter.value.ColumnOptions.map((column: any) => {
      let disable = false;

      if (selectedField) {
        if (this.isSummaryCondition) {
          const { name: selectedFieldName, value: selectedFieldValue } = selectedField;
          const extractedValue1 = this.getExtractedValue(selectedFieldValue || '');
          const extractedValue2 = this.getExtractedValue(column.name || '');

          if (extractedValue1 === extractedValue2) {
            const cleanVal1 = (selectedFieldValue as string || '').replace(selectedFieldName || '', '').replace(/^_+|_+$/g, '');
            const cleanVal2 = (column.value || '').replace(column.name || '', '').replace(/^_+|_+$/g, '');

            if (cleanVal1 === cleanVal2 || selectedFieldName === column.name) {
              disable = true;
            } else if (selectedFieldName && column.name) {
              const nameDiff = selectedFieldName.length - column.name.length;
              const larger = nameDiff > 0 ? selectedFieldName : column.name;
              const smaller = nameDiff > 0 ? column.name : selectedFieldName;
              const cleanedDifference = larger.replace(smaller, '');

              if (cleanedDifference.includes('_')) {
                disable = true;
              }
            }
          }
        }

        // Always disable if value2 is equal
        if (column.value === selectedField.value2) {
          disable = true;
        }
      }

      return {
        ...column,
        disabled: disable,
      };
    });

    filter.patchValue({
      ColumnOptions: updatedColumnOptions,
    });
  }

  patchFilter(element: any) {
    var currentColumnType = null;
    var fieldIndex = -1;
    this.filterColumns?.forEach((field, index) => {
      if (field.value == element[this.keys.FieldKey]) {
        fieldIndex = index;
      }
    });
    if (fieldIndex >= 0) {
      var field =
        this.filterColumns == null ? null : this.filterColumns[fieldIndex];
      if (field != null) {
        var fieldName = field.name == undefined ? '' : field.name;
        if (
          field.name == 'createdby' ||
          field.name == 'modifiedby' ||
          this.createdByRegex.test(fieldName) ||
          this.modifiedByRegex.test(fieldName)
        ) {
          currentColumnType = 'user';
        } else if (
          field.name == 'datecreated' ||
          field.name == 'datemodified' ||
          this.dateCreatedRegex.test(fieldName) ||
          this.dateModifiedRegex.test(fieldName)
        ) {
          currentColumnType = 'datetime';
        } else if (field.fieldType == 'TINYINT(1)') {
          currentColumnType = 'boolean';
        } else if (field.fieldType === 'ENUM' || field.fieldType === 'ENUM2') {
          currentColumnType = field.fieldType;
        } else {
          currentColumnType = field.generalType;
        }
      }
    }
    element.CurrentFieldType = currentColumnType;

    var dateTypes = ['date', 'datetime'];
    var columns: Select2Data[] = JSON.parse(JSON.stringify(this.filterColumns));
    let currentField = this.filterColumns === null ? null : this.filterColumns[fieldIndex];

    if (columns != null) {
      if (this.isSummaryCondition) {
        columns = columns.map(function (value, index) {
          return {
            label: value.label,
            value: value.tableId + '_' + value.name!,
            name: value.name,
            fieldType: value.fieldType,
            generalType: value.generalType,
          };
        });
      } else {
        columns = columns.map(function (value, index) {
          return {
            label: value.label,
            value: value.name!,
            name: value.name,
            fieldType: value.fieldType,
            generalType: value.generalType,
          };
        });
      }

      if (element.CurrentFieldType == 'user') {
        element.ValuesFilter = columns.filter((field: Select2Data) => {
          return (
            (field.generalType == element.CurrentFieldType ||
              field.name == 'createdby' ||
              field.name == 'modifiedby' ||
              this.createdByRegex.test(field.name!) ||
              this.modifiedByRegex.test(field.name!)) &&
            element[this.keys.FieldKey] != field.value
          );
        });
      } else if (element.CurrentFieldType == 'boolean') {
        element.ValuesFilter = columns.filter((field: Select2Data) => {
          return (
            field.fieldType == 'TINYINT(1)' &&
            element[this.keys.FieldKey] != field.value
          );
        });
      } else if (dateTypes.includes(element.CurrentFieldType)) {
        element.ValuesFilter = columns.filter((field: Select2Data) => {
          var r =
            (dateTypes.includes(field.generalType!) ||
              field.name == 'datecreated' ||
              field.name == 'datemodified') &&
            element[this.keys.FieldKey] != field.value;
          return r;
        });
      } else if (currentField?.fieldType === 'ENUM' || currentField?.fieldType === 'ENUM2') {
        this.subsink.add(
          this.store.pipe(select(getDropdown)).subscribe((data: any) => {
            if (data && Object.keys(data).length > 0 && data[element.FieldKey]) {
              element.ValuesFilter = data[element.FieldKey]?.filter((option: any) => {
                if (option.IsActive) return true;
                else if (currentField?.fieldType === 'ENUM' && option.Value === element.Value) return true;
                else if (currentField?.fieldType === 'ENUM2' && element.Value.split(';').includes(option.Value)) return true;
                return false
              }).map(
                (value: any) => {
                  return {
                    label: value.Name,
                    value: value.Value
                  }
                }
              )
            } else {
              element.ValuesFilter = null;
            }
          }))
      } else {
        element.ValuesFilter = columns.filter((field: Select2Data) => {
          var r =
            field.generalType == element.CurrentFieldType &&
            field.name != 'datecreated' &&
            field.name != 'datemodified' &&
            field.name != 'createdby' &&
            field.name != 'modifiedby' &&
            !this.createdByRegex.test(field.name!) &&
            !this.modifiedByRegex.test(field.name!) &&
            !this.dateCreatedRegex.test(field.name!) &&
            !this.dateModifiedRegex.test(field.name!) &&
            field.fieldType != 'TINYINT(1)' &&
            element[this.keys.FieldKey] != field.value;
          return r;
        });
      }
    }
  }

  reset = () => {
    this.alert
      .fire(<SweetAlertOptions>{
        ...alertPresets.delete,
        text: 'Filters in this section will be removed',
      })
      .then((res) => {
        if (res.isConfirmed) {
          try {
            this.resetFilters.emit();
            this.form.clear();
            this.addGroup();
            this.form.markAsPristine();
            // this.resetFilters.emit();
          } catch (err) { }
        }
      });
  };
  prev = true;
  userFormFieldReset() {
    if (this.ConditionGroupType === 'user' && this.prev) {
      this.prev = false;
      this.form?.controls?.forEach((group: any) => {
        group?.controls?.FormConditions?.controls.forEach((form: any) => {
          form?.controls['FieldKey']?.setValue('');
          form?.controls['CurrentFieldType']?.setValue('');
          form?.controls['ValuesFilter']?.setValue([]);
          form?.controls['QueryCondition']?.setValue('');
          form?.controls['Value']?.setValue('');
        })
      })
    } else if (this.ConditionGroupType !== 'user') {
      this.prev = true;
    }
  }

  getRoleFilterCondition(filter: AbstractControl) {
    filter.patchValue({
      ValuesFilter: this.rolesOptions.map(
        (option: any) => {
          return {
            label: option.label,
            value: option.value
          }
        }
      )
    })
    filter.patchValue({
      Value: filter?.value?.Value ? filter.value.Value : null
    })
  }

  isArraysEqual(arr1: any, arr2: any) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  getFieldSize(fieldKey: string) {
    return this.filterColumns?.find(column => column.value == fieldKey)?.fieldSize || 0;
  }

  isFormTouched() {
    return (
      this.controls?.length > 1 ||
      this.controls?.some((control) => control.dirty) ||
      this.controls?.some(
        (control) =>
          ((control as UntypedFormGroup).controls[this.keys.Conditions] as UntypedFormArray)
            .controls.length > 1
      ) ||
      this.controls?.some(
        (control) =>
          (control as UntypedFormGroup).controls[this.keys.ConditionType].value ||
          (control as UntypedFormGroup).controls[this.keys.Conditions].value?.[0]?.[
          this.keys.FieldKey
          ]
      )
    );
  }

  getInputType(filter: AbstractControl) {
    if (filter.value['CurrentFieldType'] === 'id' || filter.value['CurrentFieldType'] === 'number') {
      return 'number';
    }
    return 'text';
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
    this.emitSubject.next();
    this.emitSubject.complete();
  }
}
